import { useEffect } from "react";

import { handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import { useDispatch, useSelector  } from "react-redux";
import { setStepperDisable } from "../../redux/slices/userSlice";
import { googleEvent_LOJ226 } from "../../lib/google-analytics";
import { openCredeauAccountGator } from "../../lib/credeau";
import { getCustomerID, getPhoneNo } from "../../utils/storage";

export default function FinboxCreate() {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);
  const mobile = user?.mobile || getPhoneNo();

  useEffect(() => {
    const generateFinboxURL = async () => {
      const customerId = getCustomerID();
      if (!customerId || !mobile) return;

      dispatch(setStepperDisable(true));
      try {
        await openCredeauAccountGator({
          customerId,
          mobile,
        });
        googleEvent_LOJ226();
      } catch (error) {
        console.error(error);
      }
    };

    generateFinboxURL();
  }, [dispatch, mobile]);

  return <div>{handleShowContextualLoader("Please wait...")}</div>;
}
